/**
 * @description Navigate to the URL supplied in the query string
 * @param e - The onClick event object
 */
export function navigateUrlQsp(e) {
    const destinationUrl = window.s && window.s.Util.getQueryParam('url');
    if (destinationUrl) {
        e.preventDefault();
        window.location.assign(destinationUrl);
    }
}

/**
 * @description Navigate to the previous page in the users history
 * @param e - The onClick event object
 */
export function navigateBack(e) {
    if (window.history.length > 1) {
        e.preventDefault();
        window.history.back();
    }
}

/**
 * @description Scroll to the top of the page when button is clicked
 * @param e - The onClick event object
 */
export function scrollToTop(e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

/**
 * @description Open the OneID Lightbox if OneID signup button is clicked
 * @param e - The onClick event object
 */
export function oneIdSignup(e) {
    window.oneId.openLightbox(e.currentTarget);
}

/**
 * @description Determine which action should be taken when the target button is clicked
 * @param {*} e - The onClick event object
 */
export function actionOnClick(e) {
    const target = e.currentTarget;
    const action = target.getAttribute('data-action');

    switch (action) {
        case 'onetrust-manage':
            if (window.Optanon) {
                // eslint-disable-next-line new-cap
                window.Optanon.ToggleInfoDisplay();
            }
            break;

        case 'speedbump-continue':
            navigateUrlQsp(e);
            break;

        case 'speedbump-go-back':
            navigateBack(e);
            break;

        case 'scroll-top':
            scrollToTop(e);
            break;

        case 'oneid-signup':
            oneIdSignup(e);
            break;
    }
}

/**
 * @description Scan the DOM for any elements that have the data-action attribute and attach an onclick listener.
 */
export function initButtonActions() {
    const ctas = document.querySelectorAll('[data-action]');

    ctas.forEach(cta => {
        cta.addEventListener('click', actionOnClick);
    });
}
